import script from "./CryptoChoiceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoChoiceCard.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoChoiceCard.vue?vue&type=style&index=0&id=6aa131ce&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa131ce"]])

export default __exports__